module.exports = {
  headersClientes: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Tipo", value: "tipo_cliente", sortable: true },
    { text: "Nombre", value: "nombre", sortable: false },
    { text: "Apellido", value: "apellido", sortable: false },
    { text: "Email", value: "email", sortable: false },
    { text: "Edad", value: "fecha_nacimiento", sortable: false },
    { text: "País", value: "pais", sortable: false },
    { text: "Documento", value: "tipo_documento", sortable: false },
    { text: "Número", value: "num_documento", sortable: false },
    { text: "Expedido", value: "doc_expedido", sortable: false },
    { text: "Vencimiento", value: "doc_vencimiento", sortable: false },
    { text: "Licencia", value: "licencia", sortable: false },
    { text: "Expedida", value: "lic_expedido", sortable: false },
    { text: "Vencimiento", value: "lic_vencimiento", sortable: false },
    { text: "Fax", value: "telefono", sortable: false },
    { text: "Movil", value: "telefono_movil", sortable: false },
    { text: "Dirección", value: "direccion_habitual", sortable: false },
    { text: "Municipio", value: "municipio_habitual", sortable: false },
    { text: "Provincia", value: "provincia_habitual", sortable: false },
    { text: "Dirección Local", value: "direccion_local", sortable: false },
    { text: "Municipio Local", value: "municipio_local", sortable: false },
    { text: "Provincia Local", value: "provincia_local", sortable: false },
    { text: "Reputación", value: "reputacion", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersClientesHome: [
    { text: "Id", value: "id", sortable: true },
    { text: "Nombre", value: "nombre", sortable: false },
    { text: "Apellido", value: "apellido", sortable: false },
    { text: "Movil", value: "telefono_movil", sortable: false },
  ],
  headersExtras: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Id Extra", value: "id", sortable: true },
    { text: "Nombre", value: "nombre", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersPreciosExtras: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Id Precio", value: "id", sortable: true },
    { text: "Extra", value: "extra", sortable: false },
    { text: "Precio", value: "precio", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersCoches: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Id", value: "id", sortable: true },
    { text: "Grupo", value: "grupo", sortable: true },
    { text: "Martícula", value: "matricula", sortable: false },
    { text: "Marca", value: "marca", sortable: false },
    { text: "Modelo", value: "modelo", sortable: false },
    { text: "KMs Actuales", value: "km_actual", sortable: false },
    { text: "Combustible actual", value: "combustible_actual", sortable: true },
    { text: "Estado", value: "estado", sortable: true },
  ],
  headersCochesHome: [
    { text: "Martícula", value: "matricula", sortable: false },
    { text: "KMs Actuales", value: "km_actual", sortable: false },
    {
      text: "Combustible actual",
      value: "combustible_actual",
      sortable: false,
    },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersUsuarios: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Tipo", value: "tipo", sortable: true },
    { text: "Nombre", value: "nombre", sortable: true },
    { text: "Apellido", value: "apellido", sortable: true },
    { text: "Email", value: "email", sortable: false },
    { text: "Teléfono", value: "telefono", sortable: false },
    { text: "País", value: "pais", sortable: false },
    { text: "Ciudad", value: "ciudad", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersGrupos: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Editado por", value: "usuario", sortable: true },
    { text: "Nombre", value: "nombre", sortable: true },
    { text: "Descripción", value: "descripcion", sortable: true },
    { text: "Valor Franquicia", value: "valor_franquicia", sortable: false },
    { text: "Valor Depósito", value: "valor_deposito", sortable: false },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersReservas: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "Id", value: "id", sortable: true },
    { text: "Vendedor", value: "id_usuario", sortable: true },
    { text: "Coche", value: "id_coche", sortable: false },
    { text: "Nombre", value: "nombre", sortable: false },
    { text: "Apellido", value: "apellido", sortable: false },
    { text: "Email", value: "email", sortable: false },
    { text: "Extras", value: "extra", sortable: false },
    { text: "Telefono", value: "telefono", sortable: false },
    { text: "Tarifa", value: "tarifa", sortable: false },
    { text: "Total", value: "total", sortable: false },
    { text: "Entrga", value: "fecha_recogida", sortable: true },
    { text: "Devolución", value: "fecha_entrega", sortable: true },
    { text: "Estado", value: "estado", sortable: false },
  ],
  headersContratoReservaHome: [
    { text: "ID Reserva", value: "id", sortable: true },
    { text: "ID Cliente", value: "id_persona", sortable: true },
    { text: "Nombre", value: "nombre", sortable: true },
    { text: "Apellido", value: "apellido", sortable: true },
    { text: "Movil", value: "telefono", sortable: true },
    { text: "Email", value: "email", sortable: true },
  ],
  headersTemporadas: [
    { text: "Opciones", value: "opciones", sortable: false },
    { text: "ID", value: "id", sortable: true },
    { text: "Nombre", value: "nombre", sortable: true },
    { text: "Usuario", value: "usuario", sortable: true },
    { text: "Fecha Inicio", value: "fecha_inicio", sortable: true },
    { text: "Fecha Fin", value: "fecha_fin", sortable: true },
  ],
};
